import React, { useState } from "react";
import styles from "./BetTableDragon6.module.css";

// Info tooltip component
const InfoTooltip = ({ min, max, tooltipId }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleTooltip = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsOpen(!isOpen);
  };

  const formatLimit = (value) => {
    if (value >= 1000) {
      return `${(value / 1000).toFixed(0)}K`;
    }
    return value?.toFixed(1) || "100.0";
  };

  return (
    <div className={styles.infoBlock} onClick={(e) => e.stopPropagation()}>
      <a
        href=""
        data-toggle="collapse"
        data-target={`#${tooltipId}`}
        aria-expanded={isOpen}
        className={`${styles.infoIcon} ${isOpen ? '' : 'collapsed'}`}
        onClick={toggleTooltip}
        style={{ cursor: 'pointer' }}
      >
        <i className="fas fa-info-circle m-l-10"></i>
      </a>
      <div
        id={tooltipId}
        className={`${styles.minMaxInfo} collapse ${isOpen ? 'show' : ''}`}
        onClick={(e) => e.stopPropagation()}
      >
        <span className={styles.mr5}>
          <b>Min:</b> <span>{formatLimit(min)}</span>
        </span>
        <span className={styles.mr5}>
          <b>Max:</b> <span>{formatLimit(max)}</span>
        </span>
      </div>
    </div>
  );
};

export default function BetTableDragon6({ data = [], exposures = {} }) {
  const findBetData = (name) => {
    return data.find((item) => item.nat === name) || null;
  };

  const isSuspended = (betData) => {
    return betData?.gstatus === "SUSPENDED" || !betData || betData.b === 0 || betData.b === null || betData.b === undefined;
  };

  const getExposure = (betName) => {
    if (!exposures || Object.keys(exposures).length === 0) {
      return null;
    }
    const exposureKeys = [betName, betName?.toLowerCase()];
    for (const key of exposureKeys) {
      if (exposures[key] !== undefined && exposures[key] !== null) {
        return exposures[key];
      }
    }
    return null;
  };

  const formatExposure = (value) => {
    if (!value || value === 0) return "0";
    return value < 0 ? value.toFixed(2) : `+${value.toFixed(2)}`;
  };

  const dragonBet = findBetData("Dragon");
  const tigerBet = findBetData("Tiger");
  const pairBet = findBetData("Pair");
  const dragonEven = findBetData("Dragon Even");
  const dragonOdd = findBetData("Dragon Odd");
  const dragonRed = findBetData("Dragon Red");
  const dragonBlack = findBetData("Dragon Black");
  const tigerEven = findBetData("Tiger Even");
  const tigerOdd = findBetData("Tiger Odd");
  const tigerRed = findBetData("Tiger Red");
  const tigerBlack = findBetData("Tiger Black");
  const dragonSpade = findBetData("Dragon Spade");
  const dragonHeart = findBetData("Dragon Heart");
  const dragonClub = findBetData("Dragon Club");
  const dragonDiamond = findBetData("Dragon Diamond");
  const tigerSpade = findBetData("Tiger Spade");
  const tigerHeart = findBetData("Tiger Heart");
  const tigerClub = findBetData("Tiger Club");
  const tigerDiamond = findBetData("Tiger Diamond");

  return (
    <div className={styles.container}>
      {/* Row 1: Back/Lay and Pair */}
      <div className={``}>
      <div style={{width: '100%', display:'flex', gap: '10px'}}>
          {/* Back/Lay Table */}
          <div className={`table-responsive ${styles.mainMarket}`}>
          <div className={styles.livePoker}>
            <table className={`table m-b-0 table-bordered`}>
              <thead style={{ backgroundColor: '#333d79ff', background: '#333d79ff', padding: '2px' }}>
                <tr>
                  <th className={`${styles.box6} ${styles.headerDarkBlue}`} style={{ backgroundColor: '#333d79ff', background: '#333d79ff', color: 'white', padding: '2px' }}>
                    <div className={styles.infoBlock}>
                      <InfoTooltip
                        min={dragonBet?.min || 100}
                        max={dragonBet?.max || 300000}
                        tooltipId="min-max-info1"
                      />
                    </div>
                  </th>
                  <th className={`text-center ${styles.back} ${styles.box2}`} style={{ backgroundColor: '#72bbef', background: '#72bbef', fontSize: '10px', color: '#000', fontWeight: 'bold', padding: '2px' }}>BACK</th>
                  <th className={`text-center ${styles.lay} ${styles.box2}`} style={{ backgroundColor: '#faa9ba', background: '#faa9ba', fontSize: '10px', color: '#000', fontWeight: 'bold', padding: '2px' }}>LAY</th>
                </tr>
              </thead>
              <tbody>
                <tr className={`${styles.betInfo} ${isSuspended(dragonBet) ? styles.suspendedTr : ""}`}>
                  <td className={styles.box6} style={{ backgroundColor: '#333d79ff', background: '#333d79ff', color: 'white', padding: '2px' }}>
                    <p className="m-b-0" style={{ color: 'white', fontSize: '12px', marginLeft: '10px' }}><b>Dragon</b></p>
                    <p className="m-b-0" style={{ color: (() => {
                      const exposure = getExposure("Dragon");
                      return exposure !== null && exposure > 0 ? 'red' : 'white';
                    })(), fontSize: '10px', marginLeft: '10px' }}>
                      <b>{formatExposure(getExposure("Dragon"))}</b>
                    </p>
                  </td>
                  <td
                    className={`text-center back ${styles.box2} ${isSuspended(dragonBet) ? styles.suspended : ""}`}
                    style={{ 
                      cursor: 'default',
                      backgroundColor: isSuspended(dragonBet) ? 'rgba(217, 220, 223)' : '#72bbef',
                      background: isSuspended(dragonBet) ? 'rgba(217, 220, 223)' : '#72bbef',
                      padding: '2px'
                    }}
                  >
                    <div style={{ fontSize: '14px', color: 'black', fontWeight: 'bold' }} className={`${styles.odd} d-block`}>
                      {isSuspended(dragonBet) ? "0" : (dragonBet?.b || "0")}
                    </div>
                    <div className="d-block" style={{
                      color: (() => {
                        const exposure = getExposure("Dragon");
                        return exposure !== null && exposure > 0 ? 'red' : 'black';
                      })(),
                      fontSize: '10px',
                    }}>
                      {formatExposure(getExposure("Dragon"))}
                    </div>
                  </td>
                  <td
                    className={`text-center lay ${styles.box2} ${isSuspended(dragonBet) ? styles.suspended : ""}`}
                    style={{ 
                      cursor: 'default',
                      backgroundColor: isSuspended(dragonBet) ? 'rgba(217, 220, 223)' : '#faa9ba',
                      background: isSuspended(dragonBet) ? 'rgba(217, 220, 223)' : '#faa9ba',
                      padding: '2px'
                    }}
                  >
                    <div style={{ fontSize: '14px', color: 'black', fontWeight: 'bold' }} className={`${styles.odd} d-block`}>
                      {isSuspended(dragonBet) || !dragonBet?.l ? "0" : dragonBet.l}
                    </div>
                    <div className="d-block" style={{
                      fontSize: '10px',
                      color: (() => {
                        const exposure = getExposure("Dragon");
                        return exposure !== null && exposure > 0 ? 'red' : 'black';
                      })(),
                    }}>
                      {formatExposure(getExposure("Dragon"))}
                    </div>
                  </td>
                </tr>
                <tr className={`${styles.betInfo} ${isSuspended(tigerBet) ? styles.suspendedTr : ""}`}>
                  <td className={styles.box6} style={{ backgroundColor: '#333d79ff', background: '#333d79ff', color: 'white', padding: '2px' }}>
                    <p className="m-b-0" style={{ color: 'white', fontSize: '12px', marginLeft: '10px' }}><b>Tiger</b></p>
                    <p className="m-b-0" style={{ color: (() => {
                      const exposure = getExposure("Tiger");
                      return exposure !== null && exposure > 0 ? 'red' : 'white';
                    })(), fontSize: '10px', marginLeft: '10px' }}>
                      <b>{formatExposure(getExposure("Tiger"))}</b>
                    </p>
                  </td>
                  <td
                    className={`text-center back ${styles.box2} ${isSuspended(tigerBet) ? styles.suspended : ""}`}
                    style={{ 
                      cursor: 'default',
                      backgroundColor: isSuspended(tigerBet) ? 'rgba(217, 220, 223)' : '#72bbef',
                      background: isSuspended(tigerBet) ? 'rgba(217, 220, 223)' : '#72bbef',
                      padding: '2px'
                    }}
                  >
                    <div style={{ fontSize: '14px', color: 'black', fontWeight: 'bold' }} className={`${styles.odd} d-block`}>
                      {isSuspended(tigerBet) ? "0" : (tigerBet?.b || "0")}
                    </div>
                    <div className="d-block" style={{
                      color: (() => {
                        const exposure = getExposure("Tiger");
                        return exposure !== null && exposure > 0 ? 'red' : 'black';
                      })(),
                      fontSize: '10px',
                    }}>
                      {formatExposure(getExposure("Tiger"))}
                    </div>
                  </td>
                  <td
                    className={`text-center lay ${styles.box2} ${isSuspended(tigerBet) ? styles.suspended : ""}`}
                    style={{ 
                      cursor: 'default',
                      backgroundColor: isSuspended(tigerBet) ? 'rgba(217, 220, 223)' : '#faa9ba',
                      background: isSuspended(tigerBet) ? 'rgba(217, 220, 223)' : '#faa9ba',
                      padding: '2px'
                    }}
                  >
                    <div style={{ fontSize: '14px', color: 'black', fontWeight: 'bold' }} className={`${styles.odd} d-block`}>
                      {isSuspended(tigerBet) || !tigerBet?.l ? "0" : tigerBet.l}
                    </div>
                    <div className="d-block" style={{
                      fontSize: '10px',
                      color: (() => {
                        const exposure = getExposure("Tiger");
                        return exposure !== null && exposure > 0 ? 'red' : 'black';
                      })(),
                    }}>
                      {formatExposure(getExposure("Tiger"))}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Pair Section */}
        <div className={`table-responsive  ${styles.mainMarket}`}>
          <div className="casino-content-table">
            <div className="text-center">
              <b>{pairBet?.b || "12"}</b>
              <div className={`${styles.infoBlock} float-right`}>
                <InfoTooltip
                  min={pairBet?.min || 100}
                  max={pairBet?.max || 10000}
                  tooltipId="min-max-info2"
                />
              </div>
            </div>
            <div className="m-t-10">
              <button
                className={`low-high-btn text-uppercase ${isSuspended(pairBet) ? "suspended" : ""}`}
                disabled={isSuspended(pairBet)}
                style={{ cursor: 'default' }}
              >
                Pair
              </button>
              <p className="m-b-0 m-t-10 text-center" style={{ color: 'black' }}>
                {(() => {
                  const exposure = getExposure("Pair");
                  return exposure !== null && exposure !== 0 ? formatExposure(exposure) : "0";
                })()}
              </p>
            </div>
          </div>
        </div>
      </div>
      </div>

      {/* Row 2: Even/Odd and Red/Black - Simplified for admin */}
      <div className={`row ${styles.row5} m-t-10`}>
      <div style={{width: '100%', display:'flex', gap: '10px'}}>
      <div className={`table-responsive  ${styles.mainMarket}`}>
          <div className={styles.livePoker}>
            <table className={`table m-b-0 table-bordered`}>
              <thead style={{ backgroundColor: '#333d79ff', background: '#333d79ff', padding: '2px' }}>
                <tr>
                  <th className={`${styles.box6} ${styles.headerDarkBlue}`} style={{ backgroundColor: '#333d79ff', background: '#333d79ff', color: 'white', padding: '2px' }}>
                    <div className={styles.infoBlock}>
                      <InfoTooltip
                        min={dragonEven?.min || 100}
                        max={dragonEven?.max || 25000}
                        tooltipId="min-max-info3"
                      />
                    </div>
                  </th>
                  <th className={`text-center ${styles.back} ${styles.box2}`} style={{ backgroundColor: '#72bbef', background: '#72bbef', fontSize: '10px', color: '#000', fontWeight: 'bold', padding: '2px' }}>Even</th>
                  <th className={`text-center ${styles.back} ${styles.box2}`} style={{ backgroundColor: '#72bbef', background: '#72bbef', fontSize: '10px', color: '#000', fontWeight: 'bold', padding: '2px' }}>Odd</th>
                </tr>
              </thead>
              <tbody>
                <tr className={styles.betInfo}>
                  <td className={styles.box6} style={{ backgroundColor: '#333d79ff', background: '#333d79ff', color: 'white', padding: '2px' }}>
                    <p className="m-b-0" style={{ color: 'white', fontSize: '12px', marginLeft: '10px' }}><b>Dragon</b></p>
                  </td>
                  <td className={`text-center back ${styles.box2} ${isSuspended(dragonEven) ? styles.suspended : ""}`} style={{ cursor: 'default', padding: '2px' }}>
                    <div style={{ fontSize: '14px', color: 'black', fontWeight: 'bold' }} className={`${styles.odd} d-block`}>
                      {isSuspended(dragonEven) ? "0" : (dragonEven?.b || "0")}
                    </div>
                    <div className="d-block" style={{
                      color: (() => {
                        const exposure = getExposure("Dragon Even");
                        return exposure !== null && exposure > 0 ? 'red' : 'black';
                      })(),
                      fontSize: '10px',
                    }}>
                      {formatExposure(getExposure("Dragon Even"))}
                    </div>
                  </td>
                  <td className={`text-center back ${styles.box2} ${isSuspended(dragonOdd) ? styles.suspended : ""}`} style={{ cursor: 'default', padding: '2px' }}>
                    <div style={{ fontSize: '14px', color: 'black', fontWeight: 'bold' }} className={`${styles.odd} d-block`}>
                      {isSuspended(dragonOdd) ? "0" : (dragonOdd?.b || "0")}
                    </div>
                    <div className="d-block" style={{
                      color: (() => {
                        const exposure = getExposure("Dragon Odd");
                        return exposure !== null && exposure > 0 ? 'red' : 'black';
                      })(),
                      fontSize: '10px',
                    }}>
                      {formatExposure(getExposure("Dragon Odd"))}
                    </div>
                  </td>
                </tr>
                <tr className={styles.betInfo}>
                  <td className={styles.box6} style={{ backgroundColor: '#333d79ff', background: '#333d79ff', color: 'white', padding: '2px' }}>
                    <p className="m-b-0" style={{ color: 'white', fontSize: '12px', marginLeft: '10px' }}><b>Tiger</b></p>
                  </td>
                  <td className={`text-center back ${styles.box2} ${isSuspended(tigerEven) ? styles.suspended : ""}`} style={{ cursor: 'default', padding: '2px' }}>
                    <div style={{ fontSize: '14px', color: 'black', fontWeight: 'bold' }} className={`${styles.odd} d-block`}>
                      {isSuspended(tigerEven) ? "0" : (tigerEven?.b || "0")}
                    </div>
                    <div className="d-block" style={{
                      color: (() => {
                        const exposure = getExposure("Tiger Even");
                        return exposure !== null && exposure > 0 ? 'red' : 'black';
                      })(),
                      fontSize: '10px',
                    }}>
                      {formatExposure(getExposure("Tiger Even"))}
                    </div>
                  </td>
                  <td className={`text-center back ${styles.box2} ${isSuspended(tigerOdd) ? styles.suspended : ""}`} style={{ cursor: 'default', padding: '2px' }}>
                    <div style={{ fontSize: '14px', color: 'black', fontWeight: 'bold' }} className={`${styles.odd} d-block`}>
                      {isSuspended(tigerOdd) ? "0" : (tigerOdd?.b || "0")}
                    </div>
                    <div className="d-block" style={{
                      color: (() => {
                        const exposure = getExposure("Tiger Odd");
                        return exposure !== null && exposure > 0 ? 'red' : 'black';
                      })(),
                      fontSize: '10px',
                    }}>
                      {formatExposure(getExposure("Tiger Odd"))}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Red/Black Table */}
        <div className={`table-responsive  ${styles.mainMarket}`}>
          <div className={styles.livePoker}>
            <table className={`table m-b-0 table-bordered`}>
              <thead style={{ backgroundColor: '#333d79ff', background: '#333d79ff', padding: '2px' }}>
                <tr>
                  <th className={`${styles.box6} ${styles.headerDarkBlue}`} style={{ backgroundColor: '#333d79ff', background: '#333d79ff', color: 'white', padding: '2px' }}>
                    <div className={styles.infoBlock}>
                      <InfoTooltip
                        min={dragonRed?.min || 100}
                        max={dragonRed?.max || 25000}
                        tooltipId="min-max-info4"
                      />
                    </div>
                  </th>
                  <th className={`text-center ${styles.back} ${styles.box2}`} style={{ backgroundColor: '#72bbef', background: '#72bbef', fontSize: '10px', color: '#000', fontWeight: 'bold', padding: '2px' }}>
                    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                      <div>Black</div>
                      <span className={styles.cardIcon}>
                        <img src="/assets/img/cardIcons/club.png" alt="club" style={{ width: '16px', height: '16px', marginLeft: '4px' }} />
                      </span>
                      <span className={styles.cardIcon}>
                        <img src="/assets/img/cardIcons/spade.png" alt="spade" style={{ width: '16px', height: '16px', marginLeft: '4px' }} />
                      </span>
                    </div>
                  </th>
                  <th className={`text-center ${styles.back} ${styles.box2}`} style={{ backgroundColor: '#72bbef', background: '#72bbef', fontSize: '10px', color: '#000', fontWeight: 'bold', padding: '2px' }}>
                   <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                   <div>Red</div>
                    <span className={styles.cardIcon}>
                      <img src="/assets/img/cardIcons/heart.png" alt="heart" style={{ width: '16px', height: '16px', marginLeft: '4px' }} />
                    </span>
                    <span className={styles.cardIcon}>
                      <img src="/assets/img/cardIcons/diamond.png" alt="diamond" style={{ width: '16px', height: '16px', marginLeft: '4px' }} />
                    </span>
                   </div>
                   
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr className={styles.betInfo}>
                  <td className={styles.box6} style={{ backgroundColor: '#333d79ff', background: '#333d79ff', color: 'white', padding: '2px' }}>
                    <p className="m-b-0" style={{ color: 'white', fontSize: '12px', marginLeft: '10px' }}><b>Dragon</b></p>
                  </td>
                  <td className={`text-center back ${styles.box2} ${isSuspended(dragonBlack) ? styles.suspended : ""}`} style={{ cursor: 'default', backgroundColor: isSuspended(dragonBlack) ? 'rgba(217, 220, 223)' : '#72bbef', background: isSuspended(dragonBlack) ? 'rgba(217, 220, 223)' : '#72bbef', padding: '2px' }}>
                    <div style={{ fontSize: '14px', color: 'black', fontWeight: 'bold' }} className={`${styles.odd} d-block`}>
                      {isSuspended(dragonBlack) ? "0" : (dragonBlack?.b || "0")}
                    </div>
                    <div className="d-block" style={{
                      color: (() => {
                        const exposure = getExposure("Dragon Black");
                        return exposure !== null && exposure > 0 ? 'red' : 'black';
                      })(),
                      fontSize: '10px',
                    }}>
                      {formatExposure(getExposure("Dragon Black"))}
                    </div>
                  </td>
                  <td className={`text-center back ${styles.box2} ${isSuspended(dragonRed) ? styles.suspended : ""}`} style={{ cursor: 'default', backgroundColor: isSuspended(dragonRed) ? 'rgba(217, 220, 223)' : '#72bbef', background: isSuspended(dragonRed) ? 'rgba(217, 220, 223)' : '#72bbef', padding: '2px' }}>
                    <div style={{ fontSize: '14px', color: 'black', fontWeight: 'bold' }} className={`${styles.odd} d-block`}>
                      {isSuspended(dragonRed) ? "0" : (dragonRed?.b || "0")}
                    </div>
                    <div className="d-block" style={{
                      color: (() => {
                        const exposure = getExposure("Dragon Red");
                        return exposure !== null && exposure > 0 ? 'red' : 'black';
                      })(),
                      fontSize: '10px',
                    }}>
                      {formatExposure(getExposure("Dragon Red"))}
                    </div>
                  </td>
                </tr>
                <tr className={styles.betInfo}>
                  <td className={styles.box6} style={{ backgroundColor: '#333d79ff', background: '#333d79ff', color: 'white', padding: '2px' }}>
                    <p className="m-b-0" style={{ color: 'white', fontSize: '12px', marginLeft: '10px' }}><b>Tiger</b></p>
                  </td>
                  <td className={`text-center back ${styles.box2} ${isSuspended(tigerBlack) ? styles.suspended : ""}`} style={{ cursor: 'default', backgroundColor: isSuspended(tigerBlack) ? 'rgba(217, 220, 223)' : '#72bbef', background: isSuspended(tigerBlack) ? 'rgba(217, 220, 223)' : '#72bbef', padding: '2px' }}>
                    <div style={{ fontSize: '14px', color: 'black', fontWeight: 'bold' }} className={`${styles.odd} d-block`}>
                      {isSuspended(tigerBlack) ? "0" : (tigerBlack?.b || "0")}
                    </div>
                    <div className="d-block" style={{
                      color: (() => {
                        const exposure = getExposure("Tiger Black");
                        return exposure !== null && exposure > 0 ? 'red' : 'black';
                      })(),
                      fontSize: '10px',
                    }}>
                      {formatExposure(getExposure("Tiger Black"))}
                    </div>
                  </td>
                  <td className={`text-center back ${styles.box2} ${isSuspended(tigerRed) ? styles.suspended : ""}`} style={{ cursor: 'default', backgroundColor: isSuspended(tigerRed) ? 'rgba(217, 220, 223)' : '#72bbef', background: isSuspended(tigerRed) ? 'rgba(217, 220, 223)' : '#72bbef', padding: '2px' }}>
                    <div style={{ fontSize: '14px', color: 'black', fontWeight: 'bold' }} className={`${styles.odd} d-block`}>
                      {isSuspended(tigerRed) ? "0" : (tigerRed?.b || "0")}
                    </div>
                    <div className="d-block" style={{
                      color: (() => {
                        const exposure = getExposure("Tiger Red");
                        return exposure !== null && exposure > 0 ? 'red' : 'black';
                      })(),
                      fontSize: '10px',
                    }}>
                      {formatExposure(getExposure("Tiger Red"))}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      </div>

      {/* Row 3: Suit Bets */}
      <div className={`row ${styles.row5} m-t-10`}>
        <div className={`table-responsive col-12-6 col-12 ${styles.mainMarket}`}>
          <div className={styles.livePoker}>
            <table className={`table m-b-0 table-bordered`} style={{ tableLayout: 'fixed', width: '100%' }}>
              <thead style={{ backgroundColor: '#333d79ff', background: '#333d79ff', padding: '2px' }}>
                <tr>
                  <th className={`${styles.box6} ${styles.headerDarkBlue}`} style={{ backgroundColor: '#333d79ff', background: '#333d79ff', color: 'white', padding: '2px', width: '20%' }}>
                    <div className={styles.infoBlock}>
                      <InfoTooltip
                        min={dragonSpade?.min || 100}
                        max={dragonSpade?.max || 25000}
                        tooltipId="min-max-info5"
                      />
                    </div>
                  </th>
                  <th  className={`text-center ${styles.back} ${styles.box2}`} style={{ backgroundColor: '#72bbef', background: '#72bbef', fontSize: '10px', color: '#000', fontWeight: 'bold', padding: '2px', width: '20%'}}>
                    <span style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}} className={styles.cardIcon}>
                      <img src="/assets/img/cardIcons/spade.png" alt="spade" style={{ width: '16px', height: '16px' }} />
                    </span>
                  </th>
                  <th className={`text-center ${styles.back} ${styles.box2}`} style={{ backgroundColor: '#72bbef', background: '#72bbef', fontSize: '10px', color: '#000', fontWeight: 'bold', padding: '2px', width: '20%' }}>
                    <span style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}} className={styles.cardIcon}>
                      <img src="/assets/img/cardIcons/heart.png" alt="heart" style={{ width: '16px', height: '16px' }} />
                    </span>
                  </th>
                  <th className={`text-center ${styles.back} ${styles.box2}`} style={{ backgroundColor: '#72bbef', background: '#72bbef', fontSize: '10px', color: '#000', fontWeight: 'bold', padding: '2px', width: '20%' }}>
                    <span style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}} className={styles.cardIcon}>
                      <img src="/assets/img/cardIcons/club.png" alt="club" style={{ width: '16px', height: '16px' }} />
                    </span>
                  </th>
                  <th className={`text-center ${styles.back} ${styles.box2}`} style={{ backgroundColor: '#72bbef', background: '#72bbef', fontSize: '10px', color: '#000', fontWeight: 'bold', padding: '2px', width: '20%' }}>
                    <span style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}} className={styles.cardIcon}>
                      <img src="/assets/img/cardIcons/diamond.png" alt="diamond" style={{ width: '16px', height: '16px' }} />
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr className={styles.betInfo}>
                  <td className={styles.box6} style={{ backgroundColor: '#333d79ff', background: '#333d79ff', color: 'white', padding: '2px', width: '20%' }}>
                    <p className="m-b-0" style={{ color: 'white', fontSize: '12px', marginLeft: '10px' }}><b>Dragon</b></p>
                  </td>
                  {[dragonSpade, dragonHeart, dragonClub, dragonDiamond].map((bet, idx) => (
                    <td key={idx} className={`text-center back ${styles.box2} ${isSuspended(bet) ? styles.suspended : ""}`} style={{ cursor: 'default', backgroundColor: isSuspended(bet) ? 'rgba(217, 220, 223)' : '#72bbef', background: isSuspended(bet) ? 'rgba(217, 220, 223)' : '#72bbef', padding: '2px', width: '20%' }}>
                      <div style={{ fontSize: '14px', color: 'black', fontWeight: 'bold' }} className={`${styles.odd} d-block`}>
                        {isSuspended(bet) ? "0" : (bet?.b || "0")}
                      </div>
                      <div className="d-block" style={{
                        color: (() => {
                          const exposure = getExposure(bet?.nat);
                          return exposure !== null && exposure > 0 ? 'red' : 'black';
                        })(),
                        fontSize: '10px',
                      }}>
                        {formatExposure(getExposure(bet?.nat))}
                      </div>
                    </td>
                  ))}
                </tr>
                <tr className={styles.betInfo}>
                  <td className={styles.box6} style={{ backgroundColor: '#333d79ff', background: '#333d79ff', color: 'white', padding: '2px', width: '20%' }}>
                    <p className="m-b-0" style={{ color: 'white', fontSize: '12px', marginLeft: '10px' }}><b>Tiger</b></p>
                  </td>
                  {[tigerSpade, tigerHeart, tigerClub, tigerDiamond].map((bet, idx) => (
                    <td key={idx} className={`text-center back ${styles.box2} ${isSuspended(bet) ? styles.suspended : ""}`} style={{ cursor: 'default', backgroundColor: isSuspended(bet) ? 'rgba(217, 220, 223)' : '#72bbef', background: isSuspended(bet) ? 'rgba(217, 220, 223)' : '#72bbef', padding: '2px', width: '20%' }}>
                      <div style={{ fontSize: '14px', color: 'black', fontWeight: 'bold' }} className={`${styles.odd} d-block`}>
                        {isSuspended(bet) ? "0" : (bet?.b || "0")}
                      </div>
                      <div className="d-block" style={{
                        color: (() => {
                          const exposure = getExposure(bet?.nat);
                          return exposure !== null && exposure > 0 ? 'red' : 'black';
                        })(),
                        fontSize: '10px',
                      }}>
                        {formatExposure(getExposure(bet?.nat))}
                      </div>
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

